// Library Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import loadable from "@loadable/component";
// Service Imports
import {
  fetchCalenderEvents,
  fetchAlertNotificationEvents,
  fetchNotificationEvents,
  fetchProductDetailsByPartyId,
  fetchProductDetailsAllIsActive,
  getProgressOverview,
} from "../../services/fetchLearnerDashboard.service";
import { RegisterUserService } from "../../services/registration.service";
import { LoginService } from "../../services/login.service";
import { fetchDeploymentFlagAPI } from "../../services/userManagementService";
// Reducer Imports
import { getProducts } from "../../reducer/userReducer";
import { getProfileLinkSuccess } from "../../reducer/profileLinkReducer";
import { fetchProfileLinkSuccess } from "../../action/profileLinkAction";
import {
  getCalenderEvents,
  getCalenderEventsPending,
  getCalenderEventsError,
} from "../../reducer/calenderEventsReducer";
import {
  getAlertNotificationEvents,
  getAlertNotificationEventsPending,
  getAlertNotificationEventsError,
} from "../../reducer/alertsNotificationReducer";
import {
  getNotificationEvents,
  getNotificationEventsPending,
  getNotificationEventsError,
} from "../../reducer/notificationReducer";
import {
  getProductPreRequisite,
  getProductPreRequisitePending,
  getProductPreRequisiteError,
} from "../../reducer/productPreRequisiteReducer";
import {
  getproductDetailsByParty,
  getproductDetailsByPartyPending,
  getproductDetailsByPartyError,
} from "../../reducer/productDetailsByPartyIDReducer";
import {
  getproductDetailsAll,
  getproductDetailsAllPending,
  getproductDetailsAllError,
} from "../../reducer/productDetailsAllReducer";
import {
  getPersonnelData,
  getPersonnelAddressData,
} from "../../reducer/userProfileReducer";
import {
  getUserRoleAcess,
  getUserRoleAcessError,
  getUserRoleAcessPending,
} from "../../reducer/roleAccessReducer";
import {
  getIsMaintenance,
  getTimeRemaining,
  getIsNotified,
  getTimeNotiRemaining,
  getIsClicked,
  getPending,
  getError,
} from "../../reducer/maintenanceReducer";
import {
  getLearnersProgressOverview,
  getLearnersProgressOverviewPending,
  getLearnersProgressOverviewError,
} from "../../reducer/learnerProgressOverviewReducer";
// Other Imports
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import {
  error,
  errorNotification,
} from "../../components/notification/notifications";
// Component Imports
import LoadingFallback from "../../components/loadingFallBack";
const DashboardHeader = loadable(
  () => import("../../components/dashboardheader/dashboardheader"),
  {
    fallback: <LoadingFallback />,
  }
);
const Finxfooter = loadable(() => import("../finxfooter/finxfooter"), {
  fallback: <LoadingFallback />,
});
const LearnerDashboard = loadable(
  () => import("../../components/learner-dashboard/learner-dashboard"),
  {
    fallback: <LoadingFallback />,
  }
);

const mapStateToProps = (state) => ({
  products: getProducts(state),
  profileLinkDisabled: getProfileLinkSuccess(state.profileLinkReducer),
  personnelData: getPersonnelData(state.userProfileReducers),
  addressData: getPersonnelAddressData(state.userProfileReducers),

  userRoleAccess: getUserRoleAcess(state.roleAccessReducer),
  pendingUserRoleAccess: getUserRoleAcessPending(state.roleAccessReducer),
  errorUserRoleAccess: getUserRoleAcessError(state.roleAccessReducer),

  calenderEvents: getCalenderEvents(state.calenderEventsReducer),
  pendingCalenderEvents: getCalenderEventsPending(state.calenderEventsReducer),
  errorCalanderEvents: getCalenderEventsError(state.calenderEventsReducer),

  alertNotificationEvents: getAlertNotificationEvents(
    state.alertNotificationEventsReducer
  ),
  pendingAlertNotificationEvents: getAlertNotificationEventsPending(
    state.alertNotificationEventsReducer
  ),
  errorAlertNotificationEvents: getAlertNotificationEventsError(
    state.alertNotificationEventsReducer
  ),

  notificationEvents: getNotificationEvents(state.notificationEventsReducer),
  pendingNotificationEvents: getNotificationEventsPending(
    state.notificationEventsReducer
  ),
  errorNotificationEvents: getNotificationEventsError(
    state.notificationEventsReducer
  ),

  productPreRequisite: getProductPreRequisite(state.productPreRequisiteReducer),
  pendingProductPreRequisite: getProductPreRequisitePending(
    state.productPreRequisiteReducer
  ),
  errorProductPreRequisite: getProductPreRequisiteError(
    state.productPreRequisiteReducer
  ),

  productDetailsByPartyId: getproductDetailsByParty(
    state.productDetailsByPartyIDReducer
  ),
  pendingProductDetailsByPartyId: getproductDetailsByPartyPending(
    state.productDetailsByPartyIDReducer
  ),
  errorProductDetailsByPartyId: getproductDetailsByPartyError(
    state.productDetailsByPartyIDReducer
  ),

  productDetailsAll: getproductDetailsAll(state.productDetailsAllReducer),
  pendingproductDetailsAll: getproductDetailsAllPending(
    state.productDetailsAllReducer
  ),
  errorproductDetailsAll: getproductDetailsAllError(
    state.productDetailsAllReducer
  ),

  learnerProgressOverview: getLearnersProgressOverview(
    state.learnersProgressOverviewReducer
  ),
  pendinglearnerProgressOverview: getLearnersProgressOverviewPending(
    state.learnersProgressOverviewReducer
  ),
  errorlearnerProgressOverview: getLearnersProgressOverviewError(
    state.learnersProgressOverviewReducer
  ),
  isMaintenance: getIsMaintenance(state.maintenanceReducer),
  timeRemaining: getTimeRemaining(state.maintenanceReducer),
  isClicked: getIsClicked(state.maintenanceReducer),
  isNotified: getIsNotified(state.maintenanceReducer),
  timeNotiRemaining: getTimeNotiRemaining(state.maintenanceReducer),
  pending: getPending(state.maintenanceReducer),
  error: getError(state.maintenanceReducer),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserProfileData: RegisterUserService.getUserPersonnelDetails,
      fetchUserAddressData: RegisterUserService.getUserAddress,
      fetchCalenderEvents: fetchCalenderEvents,
      fetchAlertNotificationEvents: fetchAlertNotificationEvents,
      fetchNotificationEvents: fetchNotificationEvents,
      fetchProductDetailsByPartyId: fetchProductDetailsByPartyId,
      fetchProductDetailsAllIsActive: fetchProductDetailsAllIsActive,
      fetchLearnerProfileProgressOverview: getProgressOverview,
      fetchDeploymentFlagAPI1: fetchDeploymentFlagAPI,
      fetchProfileLinkSuccess: fetchProfileLinkSuccess,
    },
    dispatch
  );

const connectFunction = connect(mapStateToProps, mapDispatchToProps);

const LearnerDashboardLandingAuthenticated = connectFunction(
  class extends Component {
    constructor(props) {
      super(props);
      console.log("LearnerDashboardLandingAuthenticated Props", props);
      this.state = {
        isVisible: false,
        isAuthorised: false,
        apiCall: true,
        apiCall1: true,
        inboxCount: "",
        notificationEvents1: [],
      };
    }

    componentDidMount() {
      let partyID = localStorage.getItem("userid-Token");
      LoginService.TokenUser((res) => {
        localStorage.setItem("jwt-token", res.responseObject);
        if (localStorage.getItem("reload") === "true") {
          localStorage.setItem("reload", "false");
          window.location.reload();
        }
      });

      const {
        fetchUserProfileData,
        fetchUserAddressData,
        fetchCalenderEvents,
        fetchAlertNotificationEvents,
        fetchNotificationEvents,
        fetchProductDetailsByPartyId,
        fetchProductDetailsAllIsActive,
        fetchLearnerProfileProgressOverview,
        fetchDeploymentFlagAPI1,
      } = this.props;

      fetchProductDetailsByPartyId("learnerPartyId=" + partyID);
      fetchCalenderEvents();
      fetchAlertNotificationEvents();
      fetchNotificationEvents("partyId=" + partyID);
      fetchProductDetailsAllIsActive(true);
      fetchUserProfileData("learnerPartyID=" + partyID);
      fetchUserAddressData("partyId=" + partyID, (res) => {});
      fetchLearnerProfileProgressOverview("learnerPartyId=" + partyID);
      fetchDeploymentFlagAPI1();
    }
    apiCallPropsSet = (value, notificationEvents1) => {
      this.setState({
        apiCall: value,
        notificationEvents1: notificationEvents1,
      });
    };
    apiCallPropsSet1 = (value, inboxCount) => {
      this.setState({ apiCall1: value, inboxCount: inboxCount });
    };

    render() {
      const {
        personnelData,
        addressData,
        products,
        calenderEvents,
        pendingCalenderEvents,
        errorCalanderEvents,
        alertNotificationEvents,
        pendingAlertNotificationEvents,
        pendingNotificationEvents,
        productPreRequisite,
        productDetailsByPartyId,
        productDetailsAll,
        pendingProductDetailsByPartyId,
        pendingproductDetailsAll,
        learnerProgressOverview,
        pendinglearnerProgressOverview,
        userRoleAccess,
        pendingUserRoleAccess,
        isMaintenance,
        timeRemaining,
        isClicked,
        isNotified,
        timeNotiRemaining,
        profileLinkDisabled,
        fetchProfileLinkSuccess,
      } = this.props;
      localStorage.setItem(
        "PersonnelData",
        JSON.stringify(this.props.personnelData)
      );
      localStorage.setItem(
        "AdminAlertNotification",
        JSON.stringify(alertNotificationEvents)
      );
      if (errorCalanderEvents === "Invalid Token") {
        error("Please Relogin.", errorNotification);
        this.props.history.push("/");
      }

      if (!pendingUserRoleAccess) {
        if (
          personnelData.status === "success" &&
          addressData.status === "success" &&
          !pendingCalenderEvents &&
          !pendingproductDetailsAll &&
          !pendingProductDetailsByPartyId &&
          !pendinglearnerProgressOverview &&
          !pendingAlertNotificationEvents &&
          !pendingNotificationEvents
        ) {
          return (
            <React.Fragment>
              <DashboardHeader
                apiCall={this.state.apiCall}
                apiCallPropsSet={this.apiCallPropsSet}
                {...this.props}
              />
              <LearnerDashboard
                isMaintenance={isMaintenance}
                timeRemaining={timeRemaining}
                isClicked={isClicked}
                isNotified={isNotified}
                timeNotiRemaining={timeNotiRemaining}
                history={this.props.history}
                products={products}
                calenderEvents={calenderEvents}
                productPreRequisite={productPreRequisite}
                productDetailsByPartyId={productDetailsByPartyId}
                personnelData={personnelData.responseObject}
                addressData={addressData.responseListObject}
                productDetailsAll={productDetailsAll}
                learnerProgressOverviewData={learnerProgressOverview}
                userRoleAccess={userRoleAccess}
                fetchProfileLinkSuccess={fetchProfileLinkSuccess}
                profileLinkDisabled={profileLinkDisabled}
              />
              <Finxfooter />
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment>
              <DashboardHeader
                apiCall={this.state.apiCall}
                apiCallPropsSet={this.apiCallPropsSet}
                apiCall1={this.state.apiCall1}
                apiCallPropsSet1={this.apiCallPropsSet1}
                inboxCount={this.state.inboxCount}
                notificationEvents1={this.state.notificationEvents1}
                {...this.props}
              />
              <PopUpPortal HidePopup={true} IsVisible={true} />
              <Finxfooter />
            </React.Fragment>
          );
        }
      } else {
        return (
          <React.Fragment>
            <DashboardHeader
              apiCall={this.state.apiCall}
              apiCallPropsSet={this.apiCallPropsSet}
              apiCall1={this.state.apiCall1}
              apiCallPropsSet1={this.apiCallPropsSet1}
              inboxCount={this.state.inboxCount}
              notificationEvents1={this.state.notificationEvents1}
              {...this.props}
            />
            <PopUpPortal HidePopup={true} IsVisible={true} />
            <Finxfooter />
          </React.Fragment>
        );
      }
    }
  }
);

export default LearnerDashboardLandingAuthenticated;
